// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductShortDescription_container__bdo5i","linkDetails":"ProductShortDescription_linkDetails__GUtA9"};